export default function Card({
  children,
  variant = 'default',
  padding = 'md',
  className = '',
  onClick
}) {

  // Base styles
  const baseStyles = 'rounded-lg border transition-all duration-300';

  // Variant styles
  const variants = {
    default: 'bg-white dark:bg-surface-dark border-border-light dark:border-border text-text-primary-light dark:text-text-primary',
    primary: 'bg-brand-primary/10 dark:bg-brand-primary/5 border-brand-primary/20 dark:border-brand-primary/30 text-text-primary-light dark:text-text-primary',
    success: 'bg-success-dark dark:bg-success-light border-success-dark dark:border-success text-text-primary-light dark:text-text-primary',
    danger: 'bg-danger-dark dark:bg-danger-light border-danger-dark dark:border-danger text-text-primary-light dark:text-text-primary',
    warning: 'bg-warning-dark dark:bg-warning-light border-warning-dark dark:border-warning text-text-primary-light dark:text-text-primary',
  };

  // Padding styles
  const paddings = {
    none: 'p-0',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  // Add cursor pointer if onClick is provided
  const cursorStyle = onClick ? 'cursor-pointer' : '';

  return (
    <div
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${paddings[padding]} ${cursorStyle} ${className}`}
    >
      {children}
    </div>
  );
}
